import React from 'react';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const productImage = 'https://cdn.magicpatterns.com/uploads/7KHpuz45MwLcVettH6PoTv/ChatGPT-Image-14-jul-2026_-01_43_33-p.m..webp';
export function FinalCTA() {
  return <section className="border-t-4 border-brand-gold bg-brand-burgundy px-4 py-7 text-center text-brand-cream sm:px-6" data-id="element-40">
      <p className="mb-1 text-xs font-bold tracking-widest text-brand-goldLight" data-id="element-41">
        EINE LETZTE CHANCE
      </p>
      <div className="mx-auto max-w-xl text-sm font-medium leading-relaxed sm:text-base" data-id="element-42">
        <p data-id="element-43">
          Deine Schüler verdienen Unterricht, der mit Struktur, Klarheit und
          pädagogischem Konzept vorbereitet wurde.
        </p>
        <p className="mt-2" data-id="element-44">
          Nicht in letzter Minute improvisiert, weil die Zeit einfach nicht
          gereicht hat.
        </p>
        <p className="mt-2" data-id="element-45">
          Hör auf, Stunden damit zu verbringen, Tanzprogramme zu erstellen,
          Choreografien zu entwickeln, Progressionspläne zu bauen und jede
          Stunde von Grund auf neu zu planen.
        </p>
        <p className="mt-2" data-id="element-46">
          Hör auf, wertvolle Zeit damit zu verschwenden, zwischen alten
          Kursunterlagen, YouTube-Videos, Ausbildungsordnern und verstreuten
          Dokumenten hin- und herzuspringen.
        </p>
        <p className="mt-2" data-id="element-47">
          Liefere jede Stunde mit Struktur, Vertrauen und einem professionellen
          Unterrichtssystem, das darauf ausgelegt ist, deinen Schülern dabei zu
          helfen, tänzerisch zu wachsen, sich frei auszudrücken und ihr volles
          Potenzial zu entfalten.
        </p>
        <p className="mt-2" data-id="element-48">
          Gib dir das komplette Tanzunterrichtssystem, das du dir von Anfang
          deiner Lehrtätigkeit an gewünscht hättest.
        </p>
      </div>
      <div className="mx-auto my-4 max-w-sm rounded-lg border border-brand-gold/50 bg-black/10 p-3" data-id="element-49">
        <p className="text-sm font-bold" data-id="element-50">
          💃 DANCE PRO™ — Das komplette 6-in-1 Planungssystem + 5 Premium-Boni
        </p>
        <p className="mt-1 text-sm" data-id="element-51">
          Regulärer Preis: <span className="line-through" data-id="element-52">97 €</span> |{' '}
          <span className="font-bold text-brand-goldLight" data-id="element-53">
            Nur heute: 27 €
          </span>
        </p>
      </div>
      <a href="#pricing" className="mb-4 block" data-id="element-54">
        <img src={productImage} alt="DANCE PRO™ Planungssystem" className="mx-auto w-full max-w-[230px] rounded-sm object-contain drop-shadow-2xl" data-id="element-55" />
      </a>
      <div className="mx-auto max-w-xl" data-id="element-56">
        <CTAButton className="!border-[#F0D5AA] !bg-brand-goldLight !text-brand-burgundy hover:!bg-[#FFEAC7]" data-id="element-57">
          🚀 JA! ICH WILL PROFESSIONELLER UNTERRICHTEN — JETZT FÜR 27 € SICHERN
        </CTAButton>
      </div>
      <div className="mt-3 flex flex-col items-center gap-1 text-[10px] font-bold text-brand-cream/90 sm:text-xs" data-id="element-58">
        <span className="flex items-center gap-1" data-id="element-59">
          <ZapIcon className="h-3.5 w-3.5 text-brand-goldLight" data-id="element-60" />
          Sofortiger Zugriff · Direkte Lieferung per E-Mail · Lebenslanger
          Zugriff
        </span>
        <span className="flex items-center gap-1" data-id="element-61">
          <StarIcon className="h-3.5 w-3.5 fill-brand-goldLight text-brand-goldLight" data-id="element-62" />
          ⭐ 4.9/5 — Bewertungen von Tanzlehrern aus Deutschland, Österreich und
          der Schweiz
        </span>
        <span className="flex items-center gap-1" data-id="element-63">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-goldLight" data-id="element-64" />
          🛡️ 7 Tage Geld-zurück-Garantie — Vollständig risikolos
        </span>
      </div>
    </section>;
}